// extracted by mini-css-extract-plugin
export default {"img":"style_img__jLk4Q"};